import React, { Component } from 'react';
import { addURL } from 'redux/actions/url';
import { Form } from "devextreme-react";
import httpRequest from 'plugin/httprequest';
import { Button } from 'devextreme-react';
import { confirmAlert } from 'react-confirm-alert'
import notify from 'devextreme/ui/notify'
import { showLoading } from 'redux/actions/loading';

class ProfilePerusahaan extends Component {
    constructor(props) {
        super(props)

        this.state = {
            formData: {}
        }

        this.formRef = React.createRef()

        this.formItems = [
            {
                itemType: 'group',
                colCount: 2,
                items: [
                    {
                        itemType: 'group',
                        items: [
                            {
                                dataField: 'participantCode',
                                label: {
                                    text: 'Kode Perusahaan',
                                },
                                editorOptions: {
                                    elementAttr: { class: "bd-input-popup-dapen-default" },
                                    placeholder: 'Kode Perusahaan'
                                }
                            },
                            {
                                dataField: 'participantName',
                                label: {
                                    text: 'Nama Perusahaan',
                                },
                                editorOptions: {
                                    elementAttr: { class: "bd-input-popup-dapen-default" },
                                    placeholder: 'Nama Perusahaan'
                                }
                            },
                            {
                                dataField: 'alamat',
                                label: {
                                    text: 'Alamat Perusahaan',
                                },
                                editorType: 'dxTextArea',
                                editorOptions: {
                                    elementAttr: { class: "bd-textarea-popup-dapen-default" },
                                    placeholder: 'Alamat Perusahaan'
                                }
                            },
                            // {
                            //     dataField: 'participantProvinceId',
                            //     label: {
                            //         text: 'Provinsi',
                            //     },
                            //     editorType: 'dxSelectBox',
                            //     editorOptions: {
                            //         elementAttr: { class: "bd-input-popup-dapen-default" },
                            //         dataSource: provinces(this.props.store),
                            //         valueExpr: 'id',
                            //         displayExpr: 'provinceName',
                            //         searcEnabled: true
                            //     }
                            // },
                            // {
                            //     dataField: 'participantCityId',
                            //     label: {
                            //         text: 'Kota',
                            //     },
                            //     editorType: 'dxSelectBox',
                            //     editorOptions: {
                            //         elementAttr: { class: "bd-input-popup-dapen-default" },
                            //         dataSource: cities(this.props.store),
                            //         valueExpr: 'id',
                            //         displayExpr: 'cityName',
                            //         searcEnabled: true
                            //     }
                            // },
                            {
                                dataField: 'email',
                                label: {
                                    text: 'Email'
                                },
                                editorOptions: {
                                    elementAttr: { class: "bd-input-popup-dapen-default" },
                                    placeholder: 'Email'
                                }
                            },
                            {
                                dataField: 'telp',
                                label: {
                                    text: 'Nomor Telepon'
                                },
                                editorOptions: {
                                    elementAttr: { class: "bd-input-popup-dapen-default" },
                                    placeholder: 'Nomor Telepon'
                                }
                            },
                            {
                                dataField: 'fax',
                                label: {
                                    text: 'Fax'
                                },
                                editorOptions: {
                                    elementAttr: { class: "bd-input-popup-dapen-default" },
                                    placeholder: 'Fax'
                                }
                            }
                        ]
                    },
                    {
                        itemType: 'empty'
                    }
                ]
            },
            {
                itemType: 'group',
                cssClass: 'mt-5',
                colCount: 2,
                items: [
                    {
                        itemType: 'group',
                        caption: 'Kepegawaian',
                        items: [
                            {
                                dataField: 'namaKepesertaan',
                                label: {
                                    text: 'Nama PIC'
                                },
                                editorOptions: {
                                    elementAttr: { class: "bd-input-popup-dapen-default" },
                                    placeholder: 'Nama PIC'
                                }
                            },
                            {
                                dataField: 'emailKepesertaan',
                                label: {
                                    text: 'Email'
                                },
                                editorOptions: {
                                    elementAttr: { class: "bd-input-popup-dapen-default" },
                                    placeholder: 'Email PIC'
                                }
                            },
                            {
                                dataField: 'telpKepesertaan',
                                label: {
                                    text: 'Nomor Telepon'
                                },
                                editorOptions: {
                                    elementAttr: { class: "bd-input-popup-dapen-default" },
                                    placeholder: 'Nomor Telepon PIC'
                                }
                            },
                            {
                                dataField: 'noHpKepesertaan',
                                label: {
                                    text: 'Nomor Handphone'
                                },
                                editorOptions: {
                                    elementAttr: { class: "bd-input-popup-dapen-default" },
                                    placeholder: 'Nomor Handphone PIC'
                                }
                            }
                        ]
                    },
                    {
                        itemType: 'group',
                        caption: 'Keuangan',
                        cssClass: 'ml-5',
                        items: [
                            {
                                dataField: 'namaKeuangan',
                                label: {
                                    text: 'Nama PIC'
                                },
                                editorOptions: {
                                    elementAttr: { class: "bd-input-popup-dapen-default" },
                                    placeholder: 'Nama PIC'
                                }
                            },
                            {
                                dataField: 'emailKeuangan',
                                label: {
                                    text: 'Email'
                                },
                                editorOptions: {
                                    elementAttr: { class: "bd-input-popup-dapen-default" },
                                    placeholder: 'Email PIC'
                                }
                            },
                            {
                                dataField: 'telpKeuangan',
                                label: {
                                    text: 'Nomor Telepon'
                                },
                                editorOptions: {
                                    elementAttr: { class: "bd-input-popup-dapen-default" },
                                    placeholder: 'Nomor Telepon PIC'
                                }
                            },
                            {
                                dataField: 'noHpKeuangan',
                                label: {
                                    text: 'Nomor Handphone'
                                },
                                editorOptions: {
                                    elementAttr: { class: "bd-input-popup-dapen-default" },
                                    placeholder: 'Nomor Handphone PIC'
                                }
                            },
                            {
                                dataField: 'tglPembayaranIuran',
                                label: {
                                    text: 'Tanggal Invoice Iuran'
                                },
                                editorType: 'dxDateBox',
                                editorOptions: {
                                    elementAttr: { class: "bd-input-popup-dapen-default" },
                                    displayFormat: 'dd MMM yyyy',
                                    useMaskBehavior: true,
                                    openOnFieldClick: true,
                                    placeholder: 'Tanggal Invoice Iuran PIC'
                                }
                            }
                        ]
                    }
                ]
            }
        ]
    }

    componentWillMount() {
        let store = this.props.store;
        store.dispatch(addURL(this.props.location.pathname))
    }

    componentDidMount = async() => {
        await this.retrieveData()
    }

    retrieveData = async () => {
        const participantId = this.props.store.getState().sessionUser ? this.props.store.getState().sessionUser.participantId : 0
        const getData = await httpRequest(process.env.REACT_APP_BACKEND_CORE, this.props.store, `participants/${participantId}`, 'GET')
        if(getData){
            this.setState({ formData: getData })
        }
    }

    submitData = async () => {
        const data = this.state.formData

        confirmAlert({
            title: 'Konfirmasi',
            message: 'Apakah anda ingin menyimpan data ini ?',
            buttons: [
                {
                    label: 'Ya',
                    onClick: async() => {
                        this.props.store.dispatch(showLoading(true))
                        try{
                            await httpRequest(process.env.REACT_APP_BACKEND_CORE, this.props.store, `participants`, 'PUT', {
                                values: data,
                                keys: data.id
                            }, data)

                            this.props.store.dispatch(showLoading(false))
                            notify({ message: 'Berhasil simpan data !', width: 'AUTO', shading: true, position: { at: 'center', my: 'center', of: window } }, 'success', 1000);
                            window.location.reload()
                        }catch(err){
                            console.error(err);
                            this.props.store.dispatch(showLoading(false))
                            notify({ message: 'Gagal simpan data !', width: 'AUTO', shading: true, position: { at: 'center', my: 'center', of: window } }, 'success', 1000);
                        }
                    }
                },
                {
                    label: 'Tidak',
                    onClick: () => {}
                },
            ]
        });
    }

    render() {
        return (
            <div className="container-fluid">
                <h2 className="main-title">Profile Perusahaan Pemberi Kerja</h2>
                
                <div className='row'>
                    <div className='col-12'>
                        <Form
                            id={"formItem"}
                            colCount={1}
                            formData={this.state.formData}
                            items={this.formItems}
                            ref={this.formRef}
                            labelLocation="left"
                        />

                        <div className='float-right'>
                            <Button 
                                type={'success'}
                                text={'Simpan'}
                                className="mr-2"
                                elementAttr={{ class: "bg-button-popup-save-dapen-default" }}
                                onClick={(e) => {this.submitData()}}
                            />
                        </div>
                    </div>
                </div>
                {/* <div className={'row fixed-bottom mr-2 mb-4'}>
                    <div className={'col-12'}>
                        <div className='float-right'>
                            <Button 
                                type={'success'}
                                text={'Simpan'}
                                className="mr-2"
                                elementAttr={{ class: "bg-button-popup-save-dapen-default" }}
                                onClick={(e) => {this.submitData()}}
                            />
                        </div>
                    </div>
                </div> */}
            </div>
        )
    }
}

export default ProfilePerusahaan